module.exports = __webpack_public_path__ + "static/img/notification.59fe5c14.svg";